import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class GetFamilyFolderListCall extends APICallV4 {
    _method = 'family/folder/list';
    _type: Method = 'get';
    _retriesCount = 0;
}
